import React, { useEffect, useState } from "react";
import AppButton from "../layout/AppButton";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import Select from "react-select";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogActions, DialogContentText } from "@mui/material";
import { FaRedo } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { apiService } from "../../services/apiClient";
import { apiUrl } from "../../services/apiUrl";
import RankedTable from "../layout/RankedTable";
import { useFaqAdmin } from "../../hooks/useFaqAdmin";

const AddFaqs = () => {
  const { faqs, faqsLoading, deleting, fetchFaqs, createFaq, updateFaq, deleteFaq } = useFaqAdmin();
  const [validated, setValidated] = useState(false);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);
  const [selectedOptionsPersona, setselectedOptionsPersona] = useState("");
  const [selectedOptionsReport, setselectedOptionsReport] = useState("");
  const [QuestionsAsk, setQuestionsAsk] = useState("");
  const [AnswerQuestions, setAnswerQuestions] = useState("");
  const [reportListValues, setReportlistValues] = useState([]);
  const [LoadingUpdate, setLoadingUpdate] = useState(false);
  const [UpdateingTable, setUpdateingTable] = useState(false);
  const [Email, setsetEmail] = useState("false");
  const [Question, setQuestion] = useState("");
  const [Answer, setAnswer] = useState("");
  const [reportName, setreportName] = useState("");
  const [reportGroupid, setreportGroupid] = useState();
  const [reportid, setreportid] = useState();
  const [faqid, setfaqid] = useState();
  const [isdelete, setisdelete] = useState(false);
  const [faqsListLoadingFaqs, setfaqsListLoadingFaqs] = useState(false);
  const [Reportname, setReportname] = useState("");
  const [userGroup, setUserGroup] = useState("");
  const [query, setQuery] = useState("");

  const [FetchPeronaReport, seFetchPeronaReport] = useState(false);

  const [resetQuestions, setresetQuestions] = useState("");
  const [resetAns, setresetAns] = useState("");
  const [personaOptions, setPersonaOptions] = useState([]);

  useEffect(() => {
    apiService.get(apiUrl.personaUserGroups())
      .then((res) => {
        const data = res.data?.data || res.data || [];
        setPersonaOptions(data.map((g) => ({ value: g.id, label: g.name })));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const groupId = selectedOptionsPersona?.value;
    if (!groupId) return;
    seFetchPeronaReport(true);
    apiService.get(apiUrl.aipdReportsByGroup(groupId))
      .then((res) => {
        const json = res.data || [];
        setReportlistValues(json.map((item) => ({ value: item[0], label: item[1] })));
        seFetchPeronaReport(false);
      })
      .catch(() => { setReportlistValues([]); seFetchPeronaReport(false); });
  }, [selectedOptionsPersona?.value]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    setValidated(true);
    setLoadingUpdate(true);
    try {
      await createFaq({
        userGroupId: selectedOptionsPersona.value,
        reportId: selectedOptionsReport.value,
        question: QuestionsAsk,
        answer: AnswerQuestions,
      });
      setValidated(false);
      setLoadingUpdate(false);
      setsuccess(true);
      await fetchFaqs();
      setAnswerQuestions("");
      setQuestionsAsk("");
      setselectedOptionsPersona("");
      setselectedOptionsReport("");
      setTimeout(() => setsuccess(false), 10000);
      seterror(false);
    } catch {
      setValidated(false);
      setLoadingUpdate(false);
      setsuccess(false);
      seterror(true);
      setTimeout(() => seterror(false), 10000);
    }
  };

  const handleChange = (selectedOptions) => {
    setselectedOptionsPersona(selectedOptions);
  };

  const handleEdit = (
    email,
    Question,
    Answer,
    reportName,
    groupid,
    reportid,
    faqid
  ) => {
    setUpdateingTable(true);
    setsetEmail(email);
    setAnswer(Answer);
    setreportName(reportName);
    setQuestion(Question);
    setfaqid(faqid);
    setreportGroupid(groupid);
    setreportid(reportid);
    setresetAns(Answer);
    setresetQuestions(Question);
  };

  // Handle delete action
  const handleDeleteFaqs = (id) => {
    setfaqid(id);
    setisdelete(true);
  };

  const handleSubmitGetFaq = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    }
    setfaqsListLoadingFaqs(true);
    try {
      await updateFaq({ userGroupId: reportGroupid, reportId: reportid, question: Question, answer: Answer, id: faqid, email: Email });
      setfaqsListLoadingFaqs(false);
      setUpdateingTable(false);
      await fetchFaqs();
    } catch {
      setfaqsListLoadingFaqs(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteFaqs = async () => {
    try {
      await deleteFaq(faqid);
      await fetchFaqs();
      setisdelete(false);
    } catch {
      // error handled in hook
    }
  };

  const pleaseWaitData = [{ value: "Please Wait...", label: "Please Wait..." }];

  const convertToLinks = (text) => {
    if (!text) return "";
    return text.replace(/(https?:\/\/[^\s]+)/g, (url) =>
      `<a class="faqslinks" href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
    );
  };

  const data = Object.values(faqs);
  const filter_by_userType = faqs ? [...new Set(faqs.map((item) => item.reportName))] : [];
  const userGroupName = faqs ? [...new Set(faqs.map((item) => item.groupName))] : [];
  const filteredData = data.filter((obj) => obj);

  const search_parameters = [
    "reportName",
    "email",
    "question",
    "answer",
    "groupName",
  ];

  function search(data) {
    return filteredData.filter(
      (item) =>
        item.reportName.includes(Reportname) &&
        item.groupName.includes(userGroup) &&
        search_parameters.some((parameter) =>
          item[parameter].toString().toLowerCase().includes(query.toLowerCase())
        )
    );
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagelimit, setPageLimit] = useState(5);

  const currentData = search(filteredData).slice(
    (currentPage - 1) * currentPagelimit,
    (currentPage - 1) * currentPagelimit + currentPagelimit
  );

  const pageCount = Math.ceil(search(filteredData).length / currentPagelimit);

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const resetAll = () => {
    setCurrentPage(1);
    setPageLimit(5);
    setReportname("");
    setQuery("");
    setUserGroup("");
  };

  const resetBtn = () => {
    setAnswerQuestions("");
    setQuestionsAsk("");
    setselectedOptionsReport("");
    setselectedOptionsPersona("");
  };

  const resetFaqs = () => {
    setAnswer(resetAns);
    setQuestion(resetQuestions);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

      {/* ── Add FAQ Form ───────────────────────────────────────────── */}
      <div style={{ background: "#fff", borderRadius: "12px", border: "1px solid #e5e7eb", boxShadow: "0 1px 3px rgba(0,0,0,0.06)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "14px 20px", borderBottom: "1px solid #f1f5f9", background: "#f8fafc" }}>
          <div style={{ width: "34px", height: "34px", borderRadius: "8px", background: "var(--app-button-color, #a70e13)", display: "grid", placeItems: "center", flexShrink: 0 }}>
            <span style={{ color: "#fff", fontSize: "20px", lineHeight: 1, marginTop: "-2px" }}>+</span>
          </div>
          <div>
            <div style={{ fontSize: "13px", fontWeight: 700, color: "#1e293b" }}>Add New FAQ</div>
            <div style={{ fontSize: "11px", color: "#94a3b8" }}>Create a frequently asked question for a report group</div>
          </div>
        </div>
        <div style={{ padding: "20px" }}>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="faqGroup">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600, color: "#475569", marginBottom: "5px" }}>User Group *</Form.Label>
                <Select options={personaOptions} required placeholder="Select group…" value={selectedOptionsPersona} onChange={handleChange} className="RlTypesCls" />
                <Form.Control.Feedback type="invalid">Group is required</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="faqReport">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600, color: "#475569", marginBottom: "5px" }}>Report *</Form.Label>
                <Select options={FetchPeronaReport ? pleaseWaitData : reportListValues} required placeholder="Select report…" value={selectedOptionsReport} onChange={(o) => setselectedOptionsReport(o)} className="RlTypesCls" />
                <Form.Control.Feedback type="invalid">Report is required</Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="faqQuestion">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600, color: "#475569", marginBottom: "5px" }}>Question *</Form.Label>
                <Form.Control autoComplete="off" required type="text" placeholder="Enter the question" value={QuestionsAsk} onChange={(e) => setQuestionsAsk(e.target.value)} className="rr-input" />
                <Form.Control.Feedback type="invalid">Question is required</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="faqAnswer">
                <Form.Label style={{ fontSize: "12px", fontWeight: 600, color: "#475569", marginBottom: "5px" }}>Answer *</Form.Label>
                <Form.Control autoComplete="off" required as="textarea" placeholder="Write the answer…" rows={4} value={AnswerQuestions} onChange={(e) => setAnswerQuestions(e.target.value)} className="rr-input rr-textarea" style={{ resize: "none" }} />
                <Form.Control.Feedback type="invalid">Answer is required</Form.Control.Feedback>
              </Form.Group>
            </Row>
            <div style={{ display: "flex", gap: "8px" }}>
              <AppButton variant="fill" disabled={LoadingUpdate} type="submit">
                {LoadingUpdate ? (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span style={{ paddingLeft: "8px" }}>Saving…</span></>) : "Save FAQ"}
              </AppButton>
              <AppButton onClick={resetBtn} variant="secondary" type="reset">Clear</AppButton>
            </div>
          </Form>
        </div>
      </div>

      {/* ── FAQ List ──────────────────────────────────────────────────── */}
      <div style={{overflow: "hidden" }}>

        {/* Toolbar */}
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "10px", padding: "12px 18px", borderBottom: "1px solid #f1f5f9", background: "#eee", marginBottom: "30px",borderRadius: "12px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "13px", fontWeight: 700, color: "#1e293b" }}>Frequently Asked Questions</span>
            <span style={{ background: "#e2e8f0", color: "#64748b", borderRadius: "20px", padding: "1px 9px", fontSize: "11px", fontWeight: 600 }}>{search(filteredData).length}</span>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "8px" }}>
            <input type="search" autoComplete="off" value={query} placeholder="Search questions, answers, email…"
              style={{ fontSize: "12px", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "5px 11px", background: "#fff", color: "#475569", minWidth: "210px", outline: "none" }}
              onChange={(e) => { setQuery(e.target.value); handlePageChange({ selected: 1 }); }} />
            <select value={Reportname} onChange={(e) => { setReportname(e.target.value); handlePageChange({ selected: 1 }); }}
              style={{ fontSize: "12px", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "5px 9px", background: "#fff", color: "#475569", outline: "none" }}>
              <option value="">All Reports</option>
              {filter_by_userType.map((item, i) => <option key={i} value={item}>{item}</option>)}
            </select>
            <select value={userGroup} onChange={(e) => setUserGroup(e.target.value)}
              style={{ fontSize: "12px", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "5px 9px", background: "#fff", color: "#475569", outline: "none" }}>
              <option value="">All Groups</option>
              {userGroupName.map((item, i) => <option key={i} value={item}>{item}</option>)}
            </select>
            <button type="button" onClick={resetAll} title="Reset filters"
              style={{ padding: "5px 8px", borderRadius: "8px", border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", color: "#64748b", display: "flex", alignItems: "center" }}>
              <FaRedo size={11} />
            </button>
          </div>
        </div>

        {/* Table */}
        {faqsLoading ? (
          <RankedTable
            columns={[{ label: "Email" }, { label: "Question" }, { label: "Answer" }, { label: "Group" }, { label: "Report" }, { label: "Actions", align: "center" }]}
            rows={Array.from({ length: 5 }, (_, i) => ({ _idx: i }))} emptyText=""
            renderRow={() => (<>{[1,2,3,4,5,6].map(j => (<td key={j} className="px-5 py-3"><div style={{ height: "13px", background: "#f1f5f9", borderRadius: "6px", width: j === 6 ? "60%" : "85%", animation: "pulse 1.5s ease-in-out infinite" }} /></td>))}</>)}
          />
        ) : (
          <RankedTable
            columns={[{ label: "Email" }, { label: "Question" }, { label: "Answer" }, { label: "Group" }, { label: "Report" }, { label: "Actions", align: "center" }]}
            rows={currentData} emptyText="No FAQs yet. Add one above."
            renderRow={(item) => (
              <>
                <td className="px-5 py-3 text-xs text-slate-500" style={{ maxWidth: "140px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={item.email}>{item.email}</td>
                <td className="px-5 py-3 text-xs font-medium text-slate-800" style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>{item.question}</td>
                <td className="px-5 py-3 text-xs text-slate-500" style={{ maxWidth: "260px", whiteSpace: "normal", wordBreak: "break-word", lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: convertToLinks(item.answer) }} />
                <td className="px-5 py-3">
                  <span style={{ background: "#dcfce7", color: "#15803d", border: "1px solid #bbf7d0", borderRadius: "20px", padding: "2px 8px", fontSize: "10px", fontWeight: 600 }}>{item.groupName}</span>
                </td>
                <td className="px-5 py-3 text-xs text-slate-500">{item.reportName}</td>
                <td className="px-5 py-3 text-center">
                  <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
                    <button type="button" style={{ padding: "3px 10px", borderRadius: "6px", border: "1px solid #bfdbfe", background: "#eff6ff", cursor: "pointer", color: "#1d4ed8", fontSize: "11px", fontWeight: 600 }}
                      onClick={() => handleEdit(item.email, item.question, item.answer, item.reportName, item.userGroupId, item.reportId, item.id)}>Edit</button>
                    <button type="button" style={{ padding: "3px 10px", borderRadius: "6px", border: "1px solid #fecaca", background: "#fff5f5", cursor: "pointer", color: "#dc2626", fontSize: "11px", fontWeight: 600 }}
                      onClick={() => handleDeleteFaqs(item.id)}>Delete</button>
                  </div>
                </td>
              </>
            )}
          />
        )}

        {/* Pagination footer */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "8px", padding: "10px 18px", borderTop: "1px solid #f1f5f9" }}>
          <span style={{ fontSize: "11px", color: "#94a3b8" }}>Showing {currentData.length} of {search(filteredData).length} FAQs</span>
          <ReactPaginate previousLabel="Previous" nextLabel="Next" breakLabel="..."
            pageCount={pageCount} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handelepageclick}
            containerClassName="pagination" pageClassName="page-item" pageLinkClassName="page-link"
            previousClassName="page-item" previousLinkClassName="page-link"
            nextClassName="page-item" nextLinkClassName="page-link"
            breakClassName="page-item" breakLinkClassName="page-link"
            activeClassName="active" forcePage={currentPage - 1} />
        </div>
      </div>

      {/* Edit Dialog */}
      {UpdateingTable && (
        <Dialog open={UpdateingTable} onClose={() => setUpdateingTable(false)} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ background: "var(--app-button-color, #a70e13)", color: "#fff", fontWeight: 500, fontSize: "15px", padding: "10px 20px" }}>Edit FAQ</DialogTitle>
          <DialogContent style={{ marginTop: "16px" }}>
            <Form noValidate validated={validated} onSubmit={handleSubmitGetFaq}>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="editEmail">
                  <Form.Label style={{ fontSize: "12px", fontWeight: 600, color: "#475569" }}>Email</Form.Label>
                  <Form.Control autoComplete="off" type="email" value={Email} disabled className="rr-input" style={{ cursor: "no-drop" }} />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="editReport">
                  <Form.Label style={{ fontSize: "12px", fontWeight: 600, color: "#475569" }}>Report Name</Form.Label>
                  <Form.Control autoComplete="off" type="text" value={reportName} disabled className="rr-input" style={{ cursor: "no-drop" }} />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="editQuestion">
                  <Form.Label style={{ fontSize: "12px", fontWeight: 600, color: "#475569" }}>Question *</Form.Label>
                  <Form.Control autoComplete="off" type="text" placeholder="Question" value={Question} required onChange={(e) => setQuestion(e.target.value)} className="rr-input" />
                  <Form.Control.Feedback type="invalid">Question is required</Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="editAnswer">
                  <Form.Label style={{ fontSize: "12px", fontWeight: 600, color: "#475569" }}>Answer *</Form.Label>
                  <Form.Control autoComplete="off" as="textarea" placeholder="Answer" value={Answer} style={{ resize: "none" }} onChange={(e) => setAnswer(e.target.value)} rows={5} required className="rr-input rr-textarea" />
                  <Form.Control.Feedback type="invalid">Answer is required</Form.Control.Feedback>
                </Form.Group>
              </Row>
              <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                <AppButton variant="fill" type="submit" disabled={faqsListLoadingFaqs}>
                  {faqsListLoadingFaqs ? (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span style={{ paddingLeft: "8px" }}>Updating…</span></>) : "Update"}
                </AppButton>
                <AppButton variant="secondary" type="reset" onClick={resetFaqs}>Reset</AppButton>
                <AppButton variant="secondary" onClick={() => setUpdateingTable(false)}>Close</AppButton>
              </div>
            </Form>
          </DialogContent>
        </Dialog>
      )}

      {/* Delete Dialog */}
      {isdelete && (
        <Dialog open={isdelete} onClose={() => setisdelete(false)}>
          <DialogTitle sx={{ fontSize: "15px", fontWeight: 600, color: "#1e293b" }}>Delete FAQ</DialogTitle>
          <DialogContent>
            <DialogContentText style={{ fontSize: "13px" }}>Are you sure you want to delete this FAQ? This action cannot be undone.</DialogContentText>
          </DialogContent>
          <DialogActions style={{ padding: "12px 16px", gap: "8px" }}>
            <AppButton variant="secondary" onClick={() => setisdelete(false)}>Cancel</AppButton>
            <AppButton variant="fill" disabled={deleting} onClick={deleteFaqs}>
              {deleting ? (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span style={{ paddingLeft: "8px" }}>Removing…</span></>) : "Delete"}
            </AppButton>
          </DialogActions>
        </Dialog>
      )}

      {issuccess && <Alert style={{ position: "fixed", right: "20px", bottom: "20px", zIndex: 9999 }} variant="success"><p className="mb-0">FAQ added successfully</p></Alert>}
      {iserror && <Alert style={{ position: "fixed", right: "20px", bottom: "20px", zIndex: 9999 }} variant="danger"><p className="mb-0">There was an issue saving. Please try again.</p></Alert>}
    </div>
  );
};

export default AddFaqs;